export const isUserWithOrg = (user) => typeof user.organizationUuid === 'string' &&
    typeof user.organizationName === 'string' &&
    user.organizationCreatedAt instanceof Date &&
    typeof user.role === 'string';
export const isSessionUser = (user) => typeof user === 'object' &&
    user !== null &&
    user.userUuid &&
    user.userId &&
    user.openId === undefined;
export const isOpenIdUser = (user) => typeof user === 'object' &&
    user !== null &&
    user.userUuid === undefined &&
    user.userId === undefined &&
    typeof user.openId === 'object' &&
    user.openId !== null &&
    typeof user.openId.subject === 'string' &&
    typeof user.openId.issuer === 'string' &&
    typeof user.openId.email === 'string' &&
    typeof user.openId.issuerType === 'string';
export var LocalIssuerTypes;
(function (LocalIssuerTypes) {
    LocalIssuerTypes["EMAIL"] = "email";
    LocalIssuerTypes["API_TOKEN"] = "apiToken";
})(LocalIssuerTypes || (LocalIssuerTypes = {}));
export const getIntrinsicUserAttributes = (user) => ({
    email: user.email,
});
//# sourceMappingURL=user.js.map